import { useCallback } from 'react';

type Params = {
    offsetValue: number;
    centerMode: boolean;
    itemWidth: number;
    bannerGreaterThanScreen: boolean;
    parentWidth: number;
    numberOfItems: number;
};

export const useCalcTrackOffset = ({
    offsetValue,
    centerMode,
    itemWidth,
    bannerGreaterThanScreen,
    parentWidth,
    numberOfItems
}: Params) => {
    const calcTrackOffset = useCallback(
        (newOffset: number) => {
            if (bannerGreaterThanScreen) {
                if (centerMode) {
                    const offset = newOffset !== undefined ? newOffset : offsetValue;
                    return -((offset + 2.5) * itemWidth - 0.5 * parentWidth);
                } else {
                    return -itemWidth;
                }
            } else {
                return 0.5 * (parentWidth - numberOfItems * itemWidth);
            }
        },
        [bannerGreaterThanScreen, centerMode, itemWidth, numberOfItems, offsetValue, parentWidth]
    );

    return { calcTrackOffset };
};
